import React from 'react';
import { Maximize2 as LucideMaximize2 } from 'lucide-react';

interface Maximize2Props {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Maximize2: React.FC<Maximize2Props> = ({ width = 24, height = 24, className, style }) => (
  <LucideMaximize2 width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Maximize2;
